import { get_domain, get_env_domain, is_localhost } from "@core/helpers/url";

export const detect_site_url = async () => {
  const _is_localhost = await is_localhost();
  if (_is_localhost) {
    return get_env_domain();
  } else {
    return String(await get_domain()).replace(":443", "");
  }
};
